
import { defineComponent, ref, onMounted, reactive, toRefs } from 'vue'
import hotBrand from '@/utils/hot-brand'
import { fetchCarBrand, fetchCarSeries, fetchCarModel } from '@/http/api'
import { Toast } from 'vant'

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    needSeries: {
      type: Boolean,
      default: true,
    },
    needModel: {
      type: Boolean,
      default: true,
    },
  },
  setup(props: any, { emit }) {
    const brandListDom: any = ref(null)
    const data: any = reactive({
      hotBrandList: [], // 热门品牌
      brandList: [],
      letterList: [],// 字母索引
      seriesList: [],
      modelList: [],
      currentBrand: {},
      carBrand: {},
      currentSeries: {},
      carSeries: {},
      currentModel: {},
      carModel: {},
      isAutoScroll: false,
      currentletter: '',
      progress: 1,
      putting: false,
      letterBoxElm: {}, // letterBoxA -> element
      isShowLoadingPop: false, // loading显示
      noneData: -1, // 暂无车系
    })

    const methods = {
      // 关闭弹窗
      close() {
        emit('toClose')
      },
      // 选中热门品牌
      chooseHotBrand(item:any) {
        methods.pickBrand({
          id: item.bid,
          name: item.title,
        })
      },
      // 选中品牌
      pickBrand(i:any) {
        data.currentBrand = i || {}
        data.carBrand = {
          id: i.id,
          name: i.name,
          image: i.logo96x96,
        }
        data.currentBrand = i || {}
        data.seriesList = []
        data.progress = 99

        // 是否显示车系
        if (props.needSeries) {
          apiMethods.getCarSeries(i.id)
          setTimeout(() => {
            data.progress = 2
          }, 200)
        } else {
          emit('toChooseCar', {
            carBrand: data.carBrand,
          })
        }
      },
      // 选中车系
      pickSeries(i:any) {
        data.currentSeries = i
        data.carSeries = {
          id: i.sgid,
          name: i.sgname,
          image: i.baiPic_180x135 || i.touPic,
          touPic: i.touPic,
        }
        data.modelList = []
        data.progress = 99

        // 是否显示车型
        if (props.needModel) {
          apiMethods.getCarModel(i.sgid)
          setTimeout(() => {
            data.progress = 3
          }, 200)
        } else {
          data.progress = 1
          emit('toChooseCar', {
            carBrand: data.carBrand,
            carSeries: data.carSeries,
          })
        }
      },
      // 选中车型
      pickModel(i:any) {
        if (i.caption) return
        if (data.putting) {
          return
        }
        data.putting = true
        setTimeout(() => {
          data.putting = false
        }, 5000)
        data.currentModel = i
        data.carModel = {
          id: i.id,
          name: i.title,
          image: '',
        }

        emit('toChooseCar', {
          carBrand: data.carBrand,
          carSeries: data.carSeries,
          carModel: data.carModel,
        })
      },
      // 选中字母，定位车品牌
      chooseCate(item:any) {
        data.isAutoScroll = true
        data.brandList.forEach((obj:any) => {
          obj.active = false
        })
        item.active = true
        data.currentletter = item.letter
        setTimeout(() => {
          brandListDom.value.scrollTop = item.offsetTop
        }, 1)
      },
      initScroll() {
        let _safeTopH = 0
        data.brandList.map((item:any) => {
          item.clientRect =
            data.letterBoxElm[`letterBox${item.letter}`].getBoundingClientRect()
          item.offsetTop = item.clientRect.top - _safeTopH
          item.durationH = item.offsetTop + item.clientRect.height
          return item
        })
        brandListDom.value.addEventListener('scroll', methods.brandListScroll)
      },
      brandListScroll() {
        if (data.isAutoScroll) {
          data.isAutoScroll = false
          return
        }
        window.requestAnimationFrame(() => {
          let _scrollTop = brandListDom.value.scrollTop
          data.brandList.forEach((item:any, index:any) => {
            if (
              _scrollTop > item.offsetTop - 12 &&
              _scrollTop <=
                (data.brandList[index + 1]
                  ? data.brandList[index + 1].offsetTop
                  : _scrollTop)
            ) {
              item.active = true
              data.currentletter = item.letter
            } else {
              item.active = false
              if (_scrollTop <= 0) {
                data.currentletter = ''
              }
            }
          })
        })
      },
    }

    const apiMethods = {
      // 获取车品牌
      async getBrand() {
        data.isShowLoadingPop = true
        let res: any = await fetchCarBrand()
        if (res.code === 200) {
          data.brandList = res.data.brandList.map((obj:any) => {
            obj.active = false
            return obj
          })
          data.letterList = res.data.brandList.map((obj:any) => {
            return obj.letter
          })
          data.isShowLoadingPop = false
        } else {
          data.isShowLoadingPop = false
          Toast(res.message)
        }
      },
      // 获取车系
      async getCarSeries(brandId:any) {
        data.isShowLoadingPop = true
        let res: any = await fetchCarSeries(brandId)
        if (res.code === 200) {
          data.seriesList = res.data
          if (data.seriesList.length) {
            data.noneData = 1
          } else {
            data.noneData = 0
          }
          data.isShowLoadingPop = false
        } else {
          data.isShowLoadingPop = false
          Toast(res.message)
        }
      },
      // 获取车型
      async getCarModel(seriesId:any) {
        let res: any = await fetchCarModel(seriesId)
        if (res.code === 200) {
          data.modelList = res.data || []
        } else {
          Toast(res.message)
        }
      },
    }
    onMounted(() => {
      data.hotBrandList = hotBrand
      apiMethods.getBrand()
      if (props.visible) {
        setTimeout(() => {
          // methods.initScroll()
        }, 500)
      }
    })
    return {
      ...toRefs(data),
      brandListDom,
      methods,
      apiMethods,
    }
  },
})
